/**
 * TODO 메모 체크리스트.
 * 본문에는 문자(☐ 미체크 / ☑ 체크)로 저장하고, 표시 화면에서만 그림 체크박스로 그린다.
 * 기존 글머리표(■ 등)와 겹치지 않도록 ☐/☑만 인식한다.
 */
export const TODO_CHECK_OFF = '☐';
export const TODO_CHECK_ON = '☑';

const isBox = (ch: string | undefined) => ch === TODO_CHECK_OFF || ch === TODO_CHECK_ON;

function lineStartOf(text: string, index: number): number {
  return text.lastIndexOf('\n', Math.max(0, index - 1)) + 1;
}

/** 줄 맨 앞(들여쓰기 뒤) 체크박스 문자 위치, 없으면 -1 */
function boxIndexInLine(text: string, lineStart: number): number {
  let i = lineStart;
  while (text[i] === ' ' || text[i] === '\t') i += 1;
  return isBox(text[i]) ? i : -1;
}

export type TodoChecklistEdit = { text: string; caret: number };

/**
 * 입력창에서 체크박스 문자를 클릭(커서가 문자 바로 앞·뒤)했을 때 ☐↔☑ 전환.
 * 체크박스 클릭이 아니면 null.
 */
export function toggleTodoChecklistAtCaret(text: string, caret: number): TodoChecklistEdit | null {
  const boxIdx = boxIndexInLine(text, lineStartOf(text, caret));
  if (boxIdx < 0 || (caret !== boxIdx && caret !== boxIdx + 1)) return null;
  const next = text[boxIdx] === TODO_CHECK_ON ? TODO_CHECK_OFF : TODO_CHECK_ON;
  return {
    text: text.slice(0, boxIdx) + next + text.slice(boxIdx + 1),
    caret: boxIdx + 1,
  };
}

/** 커서가 있는 줄 앞에 ☐ 추가(이미 체크박스 줄이면 제거) */
export function toggleTodoChecklistLine(text: string, caret: number): TodoChecklistEdit {
  const lineStart = lineStartOf(text, caret);
  const boxIdx = boxIndexInLine(text, lineStart);
  if (boxIdx >= 0) {
    const removeLen = text[boxIdx + 1] === ' ' ? 2 : 1;
    return {
      text: text.slice(0, boxIdx) + text.slice(boxIdx + removeLen),
      caret: Math.max(boxIdx, caret - removeLen),
    };
  }
  const insert = `${TODO_CHECK_OFF} `;
  return {
    text: text.slice(0, lineStart) + insert + text.slice(lineStart),
    caret: caret + insert.length,
  };
}

export type TodoChecklistLine =
  | { kind: 'text'; text: string }
  | { kind: 'check'; checked: boolean; indent: string; spaced: boolean; text: string };

export function parseTodoChecklistLines(text: string): TodoChecklistLine[] {
  return text.split('\n').map((line) => {
    const m = /^([ \t]*)([☐☑])( ?)(.*)$/.exec(line);
    if (!m) return { kind: 'text', text: line };
    return {
      kind: 'check',
      checked: m[2] === TODO_CHECK_ON,
      indent: m[1],
      spaced: m[3] === ' ',
      text: m[4],
    };
  });
}

export function hasTodoChecklist(text: string): boolean {
  return /(^|\n)[ \t]*[☐☑]/.test(text);
}
